import { formatDateMoment } from 'utils/utils'

export const Timeline = ({ data }) => {
    return (
        <div className={'max-h-[25rem] overflow-scroll'}>
            {data.map((item, index) => (
                <div key={index}>
                    <div className={'flex flex-row gap-5'}>
                        <div className={'flex flex-col items-center'}>
                            {index === 0 ? (
                                <div
                                    className={
                                        'rounded-full w-6 h-6 border-4 border-blue-10 flex flex-col justify-center items-center bg-blue-90'
                                    }
                                >
                                    <div className={'rounded-full w-2 h-2 bg-white'} />
                                </div>
                            ) : (
                                <div className={'px-1.5 flex flex-col justify-center items-center'}>
                                    <div className={'w-3 h-3 rounded-full bg-neutral-50'} />
                                </div>
                            )}
                            {index !== data?.length - 1 && (
                                <div className={`w-1 bg-neutral-10 ${item?.image?.length !== 0 ? 'h-24' : 'h-16'}`} />
                            )}
                        </div>
                        <div className={'space-y-1 text-neutral-60'}>
                            <p className={'max-h-14 overflow-scroll font-bold capitalize'}>{item?.text}</p>
                            <div className={'flex flex-wrap gap-[6px]'}>
                                {item?.images?.map((url, index) => (
                                    <img
                                        src={url}
                                        alt={`image-${index}`}
                                        className={'w-10 h-10 border border-neutral-20'}
                                    />
                                ))}
                            </div>
                            <p>{formatDateMoment(item?.created_at, 'DD MMM YYYY, HH:mm')}</p>
                        </div>
                    </div>
                </div>
            ))}
        </div>
    )
}
